import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block1-标准版.png")